import { NavType } from '../constants';
const getNavType = navConfigResponse => {
  if (!('portal' in navConfigResponse)) {
    return NavType.HUBLESS;
  }
  return NavType.VERTICAL;
};
export default getNavType;